import { createFileRoute } from "@tanstack/react-router"
import { CapabilitiesList } from "modules/capabilities/components/List"
import z from "zod"

const SearchSchema = z.object({
  tab: z.enum(["installed", "marketplace"]).optional().default("installed"),
})

export const Route = createFileRoute("/_base/_auth/capabilities/list")({
  component: Component,
  validateSearch: SearchSchema,
})

function Component() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  function onChangeTab(tab: "installed" | "marketplace") {
    navigate({
      to: Route.fullPath,
      search: { tab },
    })
  }

  return <CapabilitiesList tab={tab} onChangeTab={onChangeTab} />
}
